import { useEffect } from "react";
import { useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import Loader from "../../components/loader";
const Coaching = () => {
  const { subLoading } = useSelector((state) => state.freelancer.auth);

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row gx-5"></div>
          </div>
        </div>
      </FreelancerLayout>
    </div>
  );
};

export default Coaching;
